import { render, staticRenderFns } from "./tec.vue?vue&type=template&id=ab18047e&scoped=true"
import script from "./tec.vue?vue&type=script&lang=js"
export * from "./tec.vue?vue&type=script&lang=js"
import style0 from "./tec.vue?vue&type=style&index=0&id=ab18047e&prod&scoped=scoped&lang=css"
import style1 from "./tec.vue?vue&type=style&index=1&id=ab18047e&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab18047e",
  null
  
)

export default component.exports